<template>
  <div>
    <el-input v-model="search" size="mini" placeholder="Введите для поиска" />
    <el-table
      v-loading="loading"
      :data="stevedoresList"
      style="width: 100%; margin-bottom: 20px"
    >
      <el-table-column label="Короткое название" prop="name" />
      <el-table-column label="Юр. Название" prop="legal_name" />
      <el-table-column label="Юр. Адрес" prop="legal_address" />
      <el-table-column align="right">
        <template slot-scope="scope">
          <div class="st-list-action">
            <el-button
              type="danger"
              icon="el-icon-delete"
              circle
              @click="handleDelete(scope.row.id)"
            />
            <el-button
              type="primary"
              icon="el-icon-edit"
              circle
              @click="handleEdit(scope.row)"
            />
            <el-button
              type="success"
              icon="el-icon-check"
              circle
              @click="handleSelect(scope.row.id)"
            />
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-button type="primary" @click="dialog_add_stevedore = true">
      Добавить нового стивидора
    </el-button>

    <el-dialog
      title="Добавление нового стивидора"
      :visible.sync="dialog_add_stevedore"
      width="50%"
      center
      append-to-body
      :close-on-click-modal="false"
      @close="editStevedore = {}"
    >
      <new-stevedore :obj="editStevedore" @saved="onSaved" />
    </el-dialog>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { mapGetters } from 'vuex'
import NewStevedore from './NewStevedore'

const Stevedore = RepositoryFactory.get('stevedores')

export default {
  name: 'SelectStevedore',
  components: { NewStevedore },
  data() {
    return {
      search: '',
      dialog_add_stevedore: false,
      editStevedore: {},
    }
  },
  computed: {
    ...mapGetters({
      stevedores: 'stevedores/getStevedores',
      loading: 'stevedores/getLoading',
    }),
    stevedoresList() {
      const search = String(this.search).trim().toLowerCase()

      return !search
        ? this.stevedores
        : this.stevedores.filter(data => {
            const { name, legal_name, legal_address } = data

            return (
              (name && name.toLowerCase().includes(search)) ||
              (legal_name && legal_name.toLowerCase().includes(search)) ||
              (legal_address && legal_address.toLowerCase().includes(search))
            )
          })
    },
  },
  created() {
    this.getStevedores()
  },
  methods: {
    getStevedores() {
      this.$store.dispatch('stevedores/fetchStevedores', {
        organization_id: this.userInfo.current.organization_id,
      })
    },
    handleSelect(id) {
      this.$emit('selected', id)
    },
    handleEdit(item) {
      this.editStevedore = item
      this.dialog_add_stevedore = true
    },
    handleDelete(id) {
      this.$confirm('Вы уверены что хотите удалить?', '', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Отмена',
        type: 'warning',
        customClass: this.isMobile ? 'before-del' : '',
      }).then(() =>
        Stevedore.deleteItem(id).then(() => {
          this.$message.success('Стивидор успешно удален')
          this.onSaved()
        }),
      )
    },
    onSaved() {
      this.getStevedores()
      this.dialog_add_stevedore = false
      this.editStevedore = {}
    },
  },
}
</script>

<style lang="sass" scoped>
.st-list-action
  justify-content: space-around
  display: flex
</style>
